module.exports = __webpack_public_path__ + "static/media/distance.5980a116.png";